module.exports = __webpack_public_path__ + "img/accompagnements.36df5910.png";